const isRoute = ($route:string) => {
  // check the current url request uri to see what page we requested
  const requestUri = window.location.pathname;
  return requestUri === $route;
}

export { isRoute }